import React, { Component } from "react";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import BannerImg from "../../assets/images/banner/domestic-project.png";
import { Helmet } from "react-helmet";

class DomesticProjects extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Domestic Projects | Enterprise Delivery Evidence | Avani Cimcon</title>
          <meta
            name="keywords"
            content="Comprehensive E-commerce site (Product), Ecommerce, Transport Information System, Project Management and Inventory, Disaster Management System, ERP, web based site maintenance, E-com module, client relationship management module, website customization."
          />
          <meta
            name="description"
            content="Domestic Projects preserves Avani Cimcon's enterprise implementation history in India. The page documents business process understanding, integration experience, operational systems and modernization lessons from long-term delivery work."
          />
        </Helmet>

        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Domestic Projects</h1>
            <h5>Enterprise implementations and operational delivery evidence</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <h2 className="text-primary">Enterprise implementations</h2>
              <p>
                Domestic Projects preserves software delivery work completed in India. These
                examples show how Avani Cimcon handled business process complexity, LAN-based
                systems, e-commerce workflows and operational software in real enterprise settings.
              </p>
              <p>
                The emphasis is on implementation capability and modernization lessons, not on
                promotional language.
              </p>

              <div className="shadow-sm p-4 mt-4">
                <h5 className="text-primary mb-3">Delivery experience</h5>
                <p className="mb-3">
                  This experience includes enterprise modernization, platform engineering, workflow
                  automation, legacy modernization, integration, distributed systems,
                  multilingual systems, cloud migration, enterprise architecture and operational
                  software where the project context supports it.
                </p>
                <div className="row">
                  <div className="col-md-3 mb-3">
                    <strong>Business process understanding</strong>
                    <p className="mb-0">The projects reflect real workflow and operations context.</p>
                  </div>
                  <div className="col-md-3 mb-3">
                    <strong>Integration experience</strong>
                    <p className="mb-0">Systems connect with web, LAN and back-office layers.</p>
                  </div>
                  <div className="col-md-3 mb-3">
                    <strong>Operational systems</strong>
                    <p className="mb-0">Delivery included finance, inventory and logistics tools.</p>
                  </div>
                  <div className="col-md-3 mb-3">
                    <strong>Modernization lessons</strong>
                    <p className="mb-0">Legacy systems were designed for practical business use.</p>
                  </div>
                </div>
              </div>

              <div className="shadow-sm p-4 mt-4">
                <h5 className="text-primary mb-3">Selected domestic delivery records</h5>
                <p className="mb-0">
                  The historic project names remain intact because they are part of the site’s
                  authority and search intent.
                </p>
              </div>

              <h5 className="text-primary mt-4">Comprehensive E-commerce site (Product):</h5>
              <p>
                Comprehensive e-commerce site for an office automation retail chain (undergoing
                development). We have taken the job on a turnkey basis right from the system design
                and specifications to implementation and hosting. Some of the features are fully
                database driven, web based site maintenance, catalogue maintenance, E-com module,
                comprehensive order processing module, client relationship management module, brand
                stores module, advanced search mechanisms, auction module, site customization, link
                to LAN based systems.
              </p>

              <h5 className="text-primary mt-4">Transport Information System:</h5>
              <p>
                A LAN based information system for transport operator with a geographically
                distributed network.
              </p>

              <h5 className="text-primary mt-4">Project Management and Inventory:</h5>
              <p>
                A LAN based multi-user system for keeping track of the project schedules, budgets,
                inventories and finances.
              </p>

              <h5 className="text-primary mt-4">Disaster Management System:</h5>
              <p>
                Software to simulate disaster conditions in a refinery, which predicts areas
                affected and the resources required. It also incorporates an early warning system.
              </p>

              <h5 className="text-primary mt-4">ERP</h5>
              <p>
                System for a textile plant. It does complete financial analysis, general accounting
                and gives useful MIS reports for multi-company organizations. The system runs under
                windows.
              </p>

              <p>Customized Financial Information System for a number of local businesses.</p>
            </div>

            <div className="shadow-sm p-4 mt-4 text-justify">
              <h5 className="text-primary mb-3">Why this experience matters</h5>
              <p>
                The domestic record shows that Avani Cimcon has worked inside operational systems,
                internal workflows and implementation constraints for a long time. That makes the
                page useful evidence for enterprises planning modernization work.
              </p>
              <p className="mb-0">
                Related pages:{" "}
                <Link to="/it-consulting-services">IT Consulting Services</Link>,{" "}
                <Link to="/travel-hospitality">Travel &amp; Hospitality</Link>,{" "}
                <Link to="/insurance">Insurance</Link>,{" "}
                <Link to="/healthcare">Healthcare</Link>, and <Link to="/legal">Legal</Link>.
              </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DomesticProjects;
